import IButton from '@/interfaces/IButton';

export default function (callback: () => void): IButton {
  return {
    i18n: 'common.cancel',
    variant: 'outline-info',
    onClick: callback
  };
}
